import React from "react"
import { useEffect, useState } from "react"
import styled from "@emotion/styled"
import TopicsLink from "./topics-card"
import MoreTopics from "./topics-link-older"
import TopicNotFound from "./card-notfound"

const Container = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  @media screen and (max-width: 712px) {
    height: auto;
    padding-bottom: 40px;
  }
`

const Column = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1156px;
  margin-bottom: calc(80px - 1.45rem);
  .topicColumn {
    margin: 0px 12px 24px 12px;
  }
  .topicColumn::last-child {
    margin: 0;
  }
  @media screen and (max-width: 712px) {
    max-width: none;
    flex-direction: column;
  }
  @media screen and (min-width: 712px) {
    flex-direction: column;
  }
`

const SectionTitle = styled.h1`
  height: 36px;
  width: 100%;
  max-width: 680px;
  color: #222222;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 36px;
  text-align: start;
`

const RecommendTopics = styled.div`
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  /*background-color: #f9f9f9;*/
`

const TopicsSection = props => {
  const allTopicData = props.data
  const selectedTag = props.tag
  const selectedSlug = props.slug
  const from = props.from

  const [numberOfDisplays, setNumberOfDisplays] = useState(5)
  const [filteredTopicData, setFilteredTopicData] = useState([])
  const [filteredOtherTopicData, setFilteredOtherTopicData] = useState([])
  const [notfound, setNotfound] = useState(false)
  const [isFiltered, setIsFiltered] = useState(false)
  const [notOther, setNotOther] = useState(false)

  useEffect(() => {
    if (!selectedTag) {
      setFilteredTopicData(allTopicData)
      setFilteredOtherTopicData(allTopicData)
    }
    if (selectedTag) {
      setFilteredTopicData([])
      setNumberOfDisplays(5)
      setIsFiltered(true)
      const resultsByTag = filterByTag(selectedTag)
      const resultsBySlug = filterBySlug(selectedSlug)
      /*results = intersect(resultsByTag)*/
      if (resultsByTag.length) {
        setNotfound(false)
      }
      if (!resultsByTag.length) {
        setNotfound(true)
      }
      if (!resultsBySlug.length) {
        setNotOther(true)
      }
      setFilteredTopicData(resultsByTag)
      setFilteredOtherTopicData(resultsBySlug)
    }
  }, [selectedTag])

  const showMoreTopics = () => {
    setNumberOfDisplays(numberOfDisplays + 6)
  }

  const filterByTag = selectedTag => {
    const results = []
    allTopicData.forEach(element => {
      const node = element.node
      const tag = node.category && node.category
      const tagsName = tag?.name && tag.name
      if (tagsName === selectedTag) {
        results.push(element)
      }
    })
    return results
  }

  const filterBySlug = selectedSlug => {
    const results = []
    allTopicData.forEach(element => {
      const node = element.node
      const tag = node.category && node.category
      const tagsName = tag?.name && tag.name
      if (tagsName === selectedTag && node.slug !== selectedSlug) {
        results.push(element)
      }
    })
    return results
  }

  const getTopicData = () => {
    if (!isFiltered) {
      return allTopicData
    }
    if (isFiltered && !notfound && notOther) {
      return filteredTopicData
    }
    if (isFiltered && !notfound && !notOther) {
      return filteredOtherTopicData
    }
  }

  const topicData = getTopicData()

  if (from !== "details") {
    return (
      <Container>
        <Column>
          {topicData?.length &&
            topicData.map((data, index) => {
              const dataNode = data.node
              const key = dataNode.contentful_id
              const slug = dataNode.slug
              if (slug !== selectedSlug) {
                return (
                  index + 1 <= numberOfDisplays && (
                    <TopicCard data={dataNode} key={key} />
                  )
                )
              }
            })}
          {topicData?.length && topicData.length >= numberOfDisplays && (
            <MoreTopics showMoreTopics={() => showMoreTopics()} />
          )}
          {!topicData?.length && <TopicNotFound />}
        </Column>
      </Container>
    )
  }
  if (from === "details") {
    if (notOther) {
      return (
        <RecommendTopics>
          <Container>
            <Column>
              {topicData?.length &&
                topicData.map((data, index) => {
                  if (selectedSlug !== data.node.slug) {
                    const dataNode = data.node
                    const key = dataNode.contentful_id
                    return (
                      index + 1 <= numberOfDisplays && (
                        <TopicCard data={dataNode} key={key} />
                      )
                    )
                  }
                })}
              {topicData?.length && topicData.length >= numberOfDisplays && (
                <MoreTopics showMoreTopics={() => showMoreTopics()} />
              )}
              {!topicData?.length && <TopicNotFound />}
            </Column>
          </Container>
        </RecommendTopics>
      )
    }
    if (!notOther) {
      return (
        <RecommendTopics>
          <SectionTitle>関連トピックス</SectionTitle>
          <Container>
            <Column>
              {topicData?.length &&
                topicData.map((data, index) => {
                  if (selectedSlug !== data.node.slug) {
                    const dataNode = data.node
                    const key = dataNode.contentful_id
                    const topicCard = <TopicCard data={dataNode} key={key} />
                    return index + 1 <= numberOfDisplays && topicCard
                  }
                })}
              {topicData?.length && topicData.length >= numberOfDisplays && (
                <MoreTopics showMoreTopics={() => showMoreTopics()} />
              )}
              {!topicData?.length && <TopicNotFound />}
            </Column>
          </Container>
        </RecommendTopics>
      )
    }
  }
}

const TopicCard = ({ data }) => {
  return (
    <div className="topicColumn">
      <TopicsLink data={data} />
    </div>
  )
}

export default TopicsSection
